export default __webpack_public_path__ + "static/media/banner.0a79b607.png";